export class HomeCardSearch {
    constructor(
        readonly key: SearchKeyCardType,
        readonly numberHours: number
    ) { }
}

export enum SearchKeyCardType {
    GeneratedDocuments = 'generated-documents',
    GeneratedDocumentsMostProductiveHour = 'generated-documents-most-productive-hour',
    GeneratedTransactionsMostProductiveHour = 'generated-transactions-most-productive-hour',
    GenerationErrors = 'generation-errors',
    GeneratedTransactions = 'generated-transactions',
    MostProductiveHour = 'most-productive-hour'
}